module.exports = __webpack_public_path__ + "static/media/500.b0be1da1.svg";